import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import {
  type TriggerEvaluationRecord,
  TriggerType,
} from "@/shared/domain/actions";

interface useTriggerEvaluationsProps {
  filter: {
    datasetId?: string;
    triggerName?: string;
    triggerType?: TriggerType;
  };
}

export function useTriggerEvaluations({
  filter: { datasetId, triggerName, triggerType },
}: useTriggerEvaluationsProps) {
  const { triggerService } = useDomainServices();

  return useQuery<TriggerEvaluationRecord[], Error>({
    queryKey: ["triggerEvaluations", datasetId, triggerName, triggerType],
    queryFn({ signal }) {
      if (datasetId !== undefined && triggerName !== undefined) {
        throw new Error("Cannot specify both datasetId and triggerName");
      }
      if (datasetId !== undefined) {
        return triggerService.getTriggerEvaluationsForDataset(datasetId, {
          abortSignal: signal,
        });
      }
      if (triggerName !== undefined) {
        return triggerService.getTriggerEvaluationsForTrigger(triggerName, {
          abortSignal: signal,
          triggerType,
        });
      }
      return Promise.resolve([]);
    },
  });
}
